import {buildConfig} from './config'
import {sendToParent} from './event'

export {
    buildConfig,
    sendToParent,
}
